import { render, staticRenderFns } from "./TakeQuiz.vue?vue&type=template&id=28dc08a1&"
import script from "./TakeQuiz.vue?vue&type=script&lang=js&"
export * from "./TakeQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports